import React from "react";
import { Document, Page, Text, View,   StyleSheet  } from "@react-pdf/renderer";



const styles = StyleSheet.create({
    table: {
      width: '85%',
      marginLeft:'20px'
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      borderTop: '1px solid #EEE',
      borderLeft:'2px solid #EEE',
      borderRight: '2px solid #EEE',
      borderBottom: '2px solid #EEE',
      paddingTop: 8,
      paddingBottom: 8,
    },
    header: {
      borderTop: 'none',
    },
    bold: {
      fontWeight: 'bold',
    },
    // So Declarative and unDRY 👌
    row1: {
      width: '45%',
      
     
    },
    row2: {
      width: '15%',
    },
    row3: {
      width: '15%',
    },
    row4: {
      width: '20%',
    },
    row5: {
      width: '27%',
    },
  })
const DocuPDF = ({ caso }) => {
 
  return (

  
<Document>
  <Page
        size="A4"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "left",
          backgroundColor: "white",
          marginTop:'20px'
        }}
      >
<View style={styles.table}>
    <View style={[styles.row, styles.bold, styles.header]}>
        <Text style={styles.row1}>Caso : </Text>
        <Text style={[styles.row1, {textAlign:'left' , fontSize:'13px'}]}>{caso.id}</Text>

    </View>





        
            <View style={[styles.row, styles.bold, styles.header]}>
                <Text style={styles.row1}>Fecha de Creacion : </Text>
                <Text style={[styles.row1, {textAlign:'left' , fontSize:'13px'}]}>{caso.created_date}</Text>

            </View>

       
       
            <View style={[styles.row, styles.bold, styles.header]}>
                <Text style={styles.row1}>Contacto o Precontacto : </Text>
                <Text style={[styles.row1, {textAlign:'left' , fontSize:'13px'}]}>{caso.pre_contacto===null?caso.contacto:caso.pre_contacto}</Text>

            </View>


            <View style={[styles.row, styles.bold, styles.header]}>
                <Text style={styles.row1}>Tipo de visita : </Text>
                <Text style={[styles.row1, {textAlign:'left', fontSize:'13px'}]}>{caso.tipo_visita}</Text>

            </View>


        <View style={[styles.row, styles.bold, styles.header]}>
            <Text style={styles.row1}>Estatus : </Text>
            <Text style={[styles.row1, {textAlign:'left', fontSize:'13px'}]}>{caso.estatus}</Text>

        </View>


        <View style={[styles.row, styles.bold, styles.header]}>
            <Text style={styles.row1}>Grupo técnico : </Text>
            <Text style={[styles.row1, {textAlign:'left' , fontSize:'13px'}]}>{caso.grupo_tecnico}</Text>

        </View>


        <View style={[styles.row, styles.bold, styles.header]}>
            <Text style={styles.row1}>Técnico asignado : </Text>
            <Text style={[styles.row1, {textAlign:'left', fontSize:'13px'}]}>{caso.tecnico_asignado}</Text>

        </View>


        <View style={[styles.row, styles.bold, styles.header]}>
            <Text style={styles.row1}>Fecha de asignación : </Text>
            <Text style={[styles.row1, {textAlign:'left', fontSize:'13px'}]}>{caso.fecha_asignacion}</Text>

        </View>


        
        <View style={[styles.row, styles.bold, styles.header]}>
            <Text style={[styles.row1, {width:'45%'}]}>Lapso de hora de entrada : </Text>
            <Text style={[styles.row1, {textAlign:'left', fontSize:'13px'}]}>{caso.lapso_hora_entrada}</Text>

        </View>


        <View style={[styles.row, styles.bold, styles.header]}>
            <Text style={[styles.row1, {width:'45%'}]}>Lapso de hora de salida : </Text>
            <Text style={[styles.row1, {textAlign:'left', fontSize:'13px'}]}>{caso.lapso_hora_salida}</Text>

        </View>


        <View style={[styles.row, styles.bold, styles.header]}>
            <Text style={styles.row1}>Tipo de servicio : </Text>
            <Text style={[styles.row1, {textAlign:'left', fontSize:'13px'}]}>{caso.tipo_servicio}</Text>

        </View>


        <View style={[styles.row, styles.bold, styles.header]}>
            <Text style={styles.row1}>Observaciones : </Text>
            <Text style={[styles.row1, {textAlign:'left' , fontSize:'13px'}]}>{caso.observaciones}</Text>

        </View>
        <View style={[styles.row, styles.bold, styles.header]}>
            <Text style={styles.row1}>Datos del Servicio : </Text>
            <Text style={[styles.row1, {textAlign:'left' , fontSize:'13px'}]}>{caso.datosServicio}</Text>

        </View>
        <View style={[styles.row, styles.bold, styles.header]}>
            <Text style={styles.row1}>Detalles del Servicio : </Text>
            <Text style={[styles.row1, {textAlign:'left', fontSize:'13px'}]}>{caso.detallesServicio}</Text>

        </View>

 </View>
 </Page>
    </Document>
  );
};

export default DocuPDF;
